const breakPoints = {
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1200,
  xxlarge: 1600,
};

export default breakPoints;
